export const isset = val => val != undefined && val != null;

export const boolean = val => typeof val == 'boolean';

export const numb = val => !isNaN(val) && isFinite(val) ? parseInt(val) : 0;

export const numbers = val => !val ? '' : val.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.");

export const  percentage = (value, decimals) => !isset(value) ? null : `${(parseFloat(value || 0).toFixed(!isset(decimals) ? 2 : decimals || 0)).replace('.',',')}%`;

export const each = (arr, next) => {

    if(!arr || !next) return;

    for(let i = 0; i < arr.length; i++) next(arr[i], i, i == arr.length);
};

export const timestamp = () => new Date().getTime();

export const capitalize = str => !str ? '' : (str.charAt(0).toUpperCase() + str.slice(1));

export const slugify = text => text ?
    text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\//g, 'DASH')
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/DASH/g, '/') : '';

export const uuid = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});

export const plural = (str, plural, num) => {
    
    plural && num !== 1 && (str = plural);

    return str;
};

export const datetime = (date, time) => {

    let ranges = {
        ano: 31536e6, 
        'mês': 2592e6, 
        semana: 6048e5, 
        dia: 864e5, 
        hora: 36e5, 
        minuto: 6e4
    },
    count,
    str;

    if(!date) return '';
    else {

        let dates = {
            now: new Date()
        };

        dates.date = new Date(date);

        if(time) {

            dates.time = new Date(time);

            dates.date.setHours(dates.time.getHours());
            dates.date.setMinutes(dates.time.getMinutes());
            dates.date.setSeconds(dates.time.getSeconds());
        }

        let since = dates.now - dates.date;

        if (since <= ranges.minuto) return 'mesmo agora';

        for (let i in ranges) if(count = Math.floor(since / ranges[i])) {
            str = i;
            break;
        }

        return 'há' + ' ' + count + ' ' + plural(str, str === 'mês' ? 'meses' : str + 's', count);
    }
};

//most visible element in viewport
export const filled = (elements) => {

    let element,
        max = 0;

    if(elements) for(let i in elements) if(elements[i]) {

        const visiblePx = viewport(elements[i]);

        if (visiblePx > max) {
            max = visiblePx;
            element = elements[i];
        }
    }

    return element;
};

export const viewport = (element, size) => {

    return recter(element, size || window.innerHeight || document.documentElement.clientHeight);
};

export const recter = (element, size) => {

    let res = 0;

    if(element && element.getBoundingClientRect) {

        let rect = element.getBoundingClientRect(),
            height = rect.bottom - rect.top,
            visible = {
                top: rect.top >= 0 && rect.top < size,
                bottom: rect.bottom > 0 && rect.bottom < size
            };

        if (visible.top && visible.bottom) {
            res = height;
        } else if (visible.top) {
            res = size - rect.top;
        } else if (visible.bottom) {
            res = rect.bottom;
        } else if (height > size && rect.top < 0) {
            var absTop = Math.abs(rect.top);

            if (absTop < height) {
                // Part of the element is visible
                res = height - absTop;
            }
        }
    }

    return res;
};

export default {
    isset,
    boolean,
    numb,
    numbers,
    percentage,
    viewport,
    recter,
    each,
    timestamp,
    capitalize,
    slugify,
    uuid,
    plural,
    datetime,
    filled
};